import { render, staticRenderFns } from "./criteriasTable.vue?vue&type=template&id=1bdb261a"
import script from "./criteriasTable.vue?vue&type=script&lang=js"
export * from "./criteriasTable.vue?vue&type=script&lang=js"
import style0 from "./criteriasTable.vue?vue&type=style&index=0&id=1bdb261a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports